import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateConversation = (conversationId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_CONVERSATION' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/users/conversation/${conversationId}`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_CONVERSATION_DONE',
              payload: {
                conversationId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(conversationId);
            }
          } else {
            dispatch({
              type: 'UPDATING_CONVERSATION_FAILED',
              payload: `Failed to update conversation`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_CONVERSATION_FAILED',
            payload: `Failed to update conversation`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_CONVERSATION_FAILED',
        payload: `Failed to update conversation`,
      });
    }
  };
};

export default updateConversation;
